module.exports = __webpack_public_path__ + "static/media/Home_EEE.ce3b4a5a.jpg";